import axios from 'axios';

const api = '/api/agents';

export const searchAgents = params => {
  return axios.get(`${api}${params}&cacheBuster=${new Date().getTime()}`);
};

export const getAgent = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getAgentLight = id => {
  return axios.get(`${api}/light/${id}?cacheBuster=${new Date().getTime()}`);
};

export const getCurrentStornofond = agentId => {
  return axios.get(`${api}/current-stornofond/${agentId}?cacheBuster=${new Date().getTime()}`);
};

export const getAgentEmailAddresses = () => {
  return axios.get(`${api}/emails?cacheBuster=${new Date().getTime()}`);
};

export const changePassword = account => {
  return axios.put(`${api}/changePassword?cacheBuster=${new Date().getTime()}`, account);
};

export const updateCurrentStornofond = (agentId, value) => {
  return axios.get(`${api}/update-current-stornofond/${agentId}/${value}?cacheBuster=${new Date().getTime()}`);
};

export const getStornofondEntries = (agentId: number | string) => {
  return axios.get(`${api}/${agentId}/stornofond-entries?cacheBuster=${new Date().getTime()}`);
};
